const loaders = new Map();

export function loadScript(src, type = "text/javascript") {
  if (!loaders.has(src)) {
    loaders.set(
      src,
      new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.type = type;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
          loaders.delete(src);
          script.remove();
          reject(new Error(`Failed to load ${src}`));
        };
        document.head.appendChild(script);
      })
    );
  }
  return loaders.get(src);
}
